import BaseService from './BaseService'
import entities from 'src/config/entities'

class PaymentTypeService extends BaseService {

  constructor () {
    super({entity: entities.PAYMENT_TYPE});
  }
}

export default new PaymentTypeService();
